export default {
  "首页":"首页",
  "发展历史":"发展历史",
  "资质荣誉":"资质荣誉",
  "宣传视频":"宣传视频",
  "新闻资讯":"新闻资讯",
  "产品展示":"产品展示",
  "客户案例":"客户案例",
  "下载中心":"下载中心",
  "联系我们":"联系我们",
  "公司":"公司",
  "联系人":"联系人",
  "传真":"传真",
  "邮件":"邮件",
  "邮政编码":"邮政编码",
  "网址":"网址",
  "地址":"地址",
  "在线留言":"在线留言",
  "标题":"标题",
  "请填写标题":"请填写标题",
  "姓名":"姓名",
  "请填写姓名":"请填写姓名",
  "电话":"电话",
  "请填写电话":"请填写电话",
  "内容":"内容",
  "请填写内容":"请填写内容",
  "提交消息":"提交消息",
  "邮箱":"邮箱",
  "来源":"来源",
  "创建时间":"创建时间",
  "点击量":"点击量",
  "属于":"属于",
  "上一条":"上一条",
  "下一条":"下一条",
  "产品ID":"产品ID",
  "购买价格":"购买价格",
  "发布时间":"发布时间",
  "下载":"下载",
  "暂无上一条数据":"暂无上一条数据",
  "暂无下一条数据":"暂无下一条数据",
  "登录":"登录",
}